import React from "react";
import { Box, Typography, Grid, CardContent, CardMedia } from "@mui/material";
// import { COLORS } from "../assets/commonComponents/COLORS";
import { COLORS, fontFamilyAll } from "../assets/commonComponents/COLORS";
import { IconButton } from "@mui/material";
import { AnimatedCard, IconWrapper, Overlay, PhoneNumber } from "../assets/commonComponents/css/teamCard";
import { mediaData } from "../assets/commonComponents/data";

export default function TeamSection({ data,headingText }) {
  return (
    <Box sx={{ textAlign: "center", py: 5, backgroundColor: COLORS.lightGrey }}>
      <Typography
        variant="h3"
        fontWeight="bold"
        color={COLORS.secondaryColor}
        gutterBottom
        fontFamily={fontFamilyAll}
      >
        {headingText}
      </Typography>

      <Grid container spacing={3} mt={3} justifyContent="center">
        {data.map((member) => (
          <Grid item key={member.id} xs={12} sm={6} md={3} lg={2.5}>
            <AnimatedCard elevation={3}>
              <CardMedia
                component="img"
                height="300"
                image={member.image}
                alt={member.name}
                sx={{ borderTopLeftRadius: '12px', borderTopRightRadius: '12px' }}
              />

              <Overlay className="overlay">
                <IconWrapper>
                  {mediaData.map(({ index, Icon, link }) => (
                    <IconButton
                      key={index}
                      component="a"
                      href={link}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        color:COLORS.whiteColor,
                        transition: 'transform 0.3s ease-in-out',
                        '&:hover': {
                          color: COLORS.secondaryColor,
                          transform: 'scale(1.1)',
                        }
                      }}
                    >
                      <Icon sx={{ fontSize: 32 }} />
                    </IconButton>
                  ))}
                </IconWrapper>
                <PhoneNumber>{member.phoneNumber}</PhoneNumber>
              </Overlay>
            </AnimatedCard>

            <CardContent sx={{ bgcolor: "#fff", borderRadius: "0 0 12px 12px" }}>
              <Typography
                variant="h5"
                gutterBottom
                sx={{ color: COLORS.pinkColor, fontWeight: "bold" }}
                fontFamily={fontFamilyAll}
              >
                {member.name}
              </Typography>
              <Typography variant="body2" color={COLORS.purpleColor}
              fontFamily={fontFamilyAll}
              >
                {member.role}
              </Typography>
            </CardContent>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
